import { GenericApiResponse } from '../../../../../shared/interfaces/generics';
import { RawDestination, RawDestinationType } from '../../../../../shared/interfaces/destination';
import { CreatePipelineSelectDestinationTypeWizardData } from '../interfaces/create-pipeline-destination-type-step-wizard-data';
import { DestinationTypesFactory } from '../../../../../destinations/SelectDestinationType/factories/destinationTypesFactory';
import { DestinationListFactory } from '../../../../../destinations/DestinationList/factories/destinationFactory';

export function getCreatePipelineSelectDestinationPageData(
  state: CreatePipelineSelectDestinationTypeWizardData,
  existingDestinationTypeResponse?: GenericApiResponse<RawDestination[]>,
  destinationTypeResponse?: GenericApiResponse<RawDestinationType[]>
): CreatePipelineSelectDestinationTypeWizardData {
  return {
    ...state,
    loadingPageData: false,
    configureNewDestination: !(
      existingDestinationTypeResponse && existingDestinationTypeResponse.data.length > 0
    ),
    apiError: null,
    createNewDestinationPageData: {
      ...state.createNewDestinationPageData,
      ...(destinationTypeResponse
        ? { destinationTypes: DestinationTypesFactory(destinationTypeResponse.data) }
        : {})
    },
    existingDestinationPageData: {
      ...state.existingDestinationPageData,
      ...(existingDestinationTypeResponse
        ? { destinations: DestinationListFactory(existingDestinationTypeResponse.data) }
        : {})
    }
  };
}
